
import Logs from "components/pages/logs/Logs"
import { lazy } from "react"
// lazy imports
const GenerateStock = lazy(() => import("components/pages/stock/GenerateStock"))
const Graph = lazy(() => import("components/pages/graph/Graph"))
const Log = lazy(() => import("components/pages/logs/Logs"))
// portals names
export const PORTALS_NAMES = {
  "STOCK TRACKER": "Stock Tracker Field",
  "STOCK TRACKER LOGS": "Stock Tracker",
  "STOCK TREND": "Stock Trend",

}
// portals paths
export const PORTALS = {
  [PORTALS_NAMES["STOCK TRACKER"]]: "/stock",
  [PORTALS_NAMES["STOCK TRACKER LOGS"]]: "/stock/logs",
  [PORTALS_NAMES["STOCK TREND"]]: "/stocktrend",

}

// all paths
export const PATH = {
  DEFAULT: {
    path: "/",
    pageName: "Home",
  },
  LOGIN: {
    path: '/login',
    pageName: "Login",
  },
  [PORTALS_NAMES["STOCK TRACKER"]]: {
    path: PORTALS[PORTALS_NAMES["STOCK TRACKER"]],
    pageName: "Stock Tracker",
    private: true,
    element: <GenerateStock />,
    children: {
      // LOGS: {
      //   path: PORTALS[PORTALS_NAMES["STOCK TRACKER"]] + "/logs",
      //   pageName: "FIELD",
      //   element: <div>logs</div>,
      //   sidebar: {
      //   }
      // },
    },
  },
  [PORTALS_NAMES["STOCK TRACKER LOGS"]]: {
    path: PORTALS[PORTALS_NAMES["STOCK TRACKER LOGS"]],
    private: true,
    sidebar: {},
    pageName: "Stock Tracker",
    showGenerateBtn: true,
    element: <Log />,
    children: {
      // LOGS: {
      //   path: PORTALS[PORTALS_NAMES["STOCK TRACKER"]] + "/logs",
      //   pageName: "FIELD",
      //   element: <div>logs</div>,
      //   sidebar: {
      //   }
      // },
    },
  },

  [PORTALS_NAMES["STOCK TREND"]]: {
    path: PORTALS[PORTALS_NAMES["STOCK TREND"]],
    private: true,
    children: {

      GENERATE_STOCK: {
        path: PORTALS[PORTALS_NAMES["STOCK TREND"]] + "/graph/:id",
        path_id: PORTALS[PORTALS_NAMES["STOCK TREND"]] + "/graph",
        pageName: "FIELD",
        element: <Graph />,
        sidebar: {
        }
      },
    },
  },
}

// pagination
export const PAGINATION = {
  ROWS_PER_PAGE: [10, 25, 50],
  DEFAULT_ROWS_PER_PAGE: 10,
  DEFAULT_CURRENT_PAGE: 1,
  NO_BREAK_PAGE: 4,
};


// constants
export const months = {
  Jan: "01",
  Feb: "02",
  Mar: "03",
  Apr: "04",
  May: "05",
  Jun: "06",
  Jul: "07",
  Aug: "08",
  Sep: "09",
  Oct: "10",
  Nov: "11",
  Dec: "12",
}

export const statusColors = {
  pending: {
    background: "#FFEBF9",
    color: "#DE0097"
  },
  success: {
    background: "#D2FBF0",
    color: "#0AAB83"
  },
}